import type { Config } from 'tailwindcss'

import Nesting from 'tailwindcss/nesting'

import {
  colorPalette as colors,
  shades,
  themeColors,
} from './src/constants/color-palette'
import { spacing } from './src/constants/spacing'
import bodyTypography from './src/plugins/tailwind/bodyTypography'
import drawerSize from './src/plugins/tailwind/drawerSize'
import headingTypography from './src/plugins/tailwind/headingTypography'
import innerBorder from './src/plugins/tailwind/innerBorder'
import layoutSize from './src/plugins/tailwind/layoutSize'
import modalSize from './src/plugins/tailwind/modalSize'
import utilities from './src/plugins/tailwind/utilities'
import viewportHeight from './src/plugins/tailwind/viewportHeight'

// const colors = require('tailwindcss/colors')

export default {
  content: ['./index.html', './src/**/*.{vue,js,ts,jsx,tsx}'],
  darkMode: 'class',
  safelist: [
    {
      pattern: new RegExp(`^text-(${themeColors.join('|')})$`),
    },
    {
      pattern: new RegExp(`^text-(${themeColors.join('|')})-(${shades.join('|')})$`),
    },
    {
      pattern: new RegExp(`^bg-(${themeColors.join('|')})$`),
    },
    {
      pattern: new RegExp(`^bg-(${themeColors.join('|')})-(${shades.join('|')})$`),
    },
  ],
  theme: {
    // config
    fontFamily: {
      sans: ['Forza', 'sans-serif'],
    },
    fontWeight: {
      light: '300',
      book: '400',
      medium: '500',
      bold: '700',
      black: '900',
    },
    strokeWidth: {
      0: '0',
      sm: '1',
      md: '1.2',
      lg: '1.5',
    },
    borderRadius: {
      none: '0',
      xs: '0.0625rem',
      sm: '0.125rem',
      DEFAULT: '0.25rem',
      md: '0.375rem',
      lg: '0.5rem',
      xl: '0.75rem',
      '2xl': '1rem',
      '3xl': '1.5rem',
      full: '9999px',
    },
    boxShadow: {
      none: 'none',
      sm: '0px 16px 32px -12px rgba(0, 0, 0, 0.05)',
      DEFAULT: '0px 16px 32px -12px rgba(14, 18, 27, 0.10)',
      lg: '0px 16px 32px -12px rgba(14, 18, 27, 0.20)',
      xl: '0px 16px 32px -12px rgba(14, 18, 27, 0.30)',
      '2xl': '0px 16px 32px -12px rgba(14, 18, 27, 0.40)',
    },
    backdropBlur: {
      sm: '2px',
      DEFAULT: '4px',
      md: '6px',
      lg: '8px',
      xl: '12px',
      '2xl': '20px',
    },
    screens: {
      xs: '375px', // Mobil
      sm: '576px', // Tablet
      md: '768px', // Tablet
      lg: '992px', // Desktop
      xl: '1200px', // Desktop
      '2xl': '1400px', // Desktop
    },
    spacing,
    colors: {
      primary: colors.red,
      secondary: colors.dark_blue,
      info: colors.blue,
      success: colors.green,
      warning: colors.yellow,
      danger: colors.rose,
      slate: colors.slate,
      white: colors.white,
      black: colors.black,
      indigo: colors.indigo,
      pink: colors.pink,
      rose: colors.rose,
      purple: colors.purple,
      current: colors.current,
      transparent: colors.transparent,
      inherit: colors.inherit,
    },
    extend: {
      listStyleType: {
        circle: 'circle',
      },
      fontSize: {
        xxs: ['0.65rem', '0.75rem'],
        xxxs: ['0.5rem', '0.625rem'], // 8px olarak eklenen boyut
      },
      gridTemplateColumns: {
        '1/2': '1fr 2fr',
        '1/3': '1fr 3fr',
      },
      minHeight: {
        inherit: 'inherit',
      },
      maxWidth: {
        inherit: 'inherit',
      },
      gridColumn: {
        'span-18': 'span 18 / span 18',
        'span-16': 'span 16 / span 16',
        'span-15': 'span 15 / span 15',
        'span-14': 'span 14 / span 14',
      },
    },
  },
  plugins: [
    drawerSize,
    modalSize,
    utilities,
    layoutSize,
    bodyTypography,
    viewportHeight,
    headingTypography,
    Nesting,
    innerBorder,
  ],
} as Config
